module.exports = __webpack_public_path__ + "img/P150T_weapon_14.c2ff482b.png";